import React, { Fragment, useEffect } from "react";
import "./WhyJoinUs.css";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";

function WhyJoinUs() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  };
  //
  $.fn.dataImg = function (options) {
    var settings = $.extend(
      {
        sml: 400,

        med: 800,

        lrg: 1000,

        resize: false,
      },
      options,
    );

    var elements = $(this);

    function getSrc(element) {
      var screen = $(window).width();

      if (screen > settings.med) {
        return element.data("lrg");
      } else if (screen <= settings.med && screen > settings.sml) {
        return element.data("med");
      }

      return element.data("sml");
    }

    function breakpoints() {
      elements.each(function () {
        var e = $(this);

        var src = getSrc(e);

        if (src != undefined) {
          if (e.is("img")) {
            e.attr("src", src);
          } else {
            e.css("background-image", "url(" + src + ")");
          }
        }
      });
    }
    breakpoints();

    if (settings.resize === true) {
      $(window).resize(function () {
        breakpoints();
      });
    }
  };

  var plannerSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  //
  // $(document).ready(function () {
  // 	$(".header-mobile-menu").click(function () {
  // 		$(".nav-wrapper").toggleClass("show-menu");
  // 	});
  // });
  $(document).ready(function () {
    // $(".header-mobile-menu").click(function () {
    // 	$(".nav-wrapper").toggleClass("show-menu");
    // });

    setTimeout(function () {
      $(".academy2").css("display", "none");
      $(".academy3").css("display", "none");
      $(".academy4").css("display", "none");
      $(".academy5").css("display", "none");
      $(".academy6").css("display", "none");
      $(".academy7").css("display", "none");
      $(".academy8").css("display", "none");
      $(".academy9").css("display", "none");
    }, 1000);

    $(".academybtncntr li").click(function () {
      $(".academybtncntr li").removeClass("active");
      $(this).addClass("active");

      if ($("#academy1").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy1").css("display", "block");
      }
      if ($("#academy2").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy2").css("display", "block");
      }
      if ($("#academy3").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy3").css("display", "block");
      }
      if ($("#academy4").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy4").css("display", "block");
      }
      if ($("#academy5").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy5").css("display", "block");
      }
      if ($("#academy6").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy6").css("display", "block");
      }
      if ($("#academy7").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy7").css("display", "block");
      }
      if ($("#academy8").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy8").css("display", "block");
      }
      if ($("#academy9").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy9").css("display", "block");
      }
    });
  });

  $(document).ready(function () {
    $(".facilities-view1").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      // //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view2").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view3").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view4").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view5").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view6").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view7").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view8").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view9").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  });

  return (
    <>
      <div className="main-container full_width why-join-us">
        <section className="section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg  wju-section-1  my-0 py-0 section-container">
          <div className="container">
            <div className="row d-flex">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Why Jio Institute
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="row align-items-lg-center">
              <div className="col-lg-7" data-aos="fade-right">
                <h1 className="h1-01 font-black mb-3 text-lg-left text-center">
                  Why Jio Institute
                </h1>
                <div className="d-lg-none mt-lg-0 mt-5">
                  <div className="rounded-circle masthead-rounded-circle-mob overflow-hidden">
                    <img
                      src="assets/images/career/about.jpg"
                      alt="about"
                      className="w-100"
                    />
                  </div>
                </div>
                <div className="h4-04">
                  <p>
                    Jio Institute is envisioned as a next-generation institution
                    committed to excellence in teaching, research, and societal
                    impact. Established with the aspiration to be among the
                    world’s leading institutions, Jio Institute brings together
                    the strengths of academic rigor, industry integration, and
                    technological advancement.
                  </p>
                  <p>
                    As part of this journey, we are building a community of
                    exceptional individuals who are driven by purpose, inspired
                    by innovation, and committed to creating meaningful impact.
                  </p>
                  <p>
                    Working at Jio Institute is not just about taking up a
                    role—it is about contributing to the creation of a
                    forward-looking institution that nurtures talent, fosters
                    discovery, and addresses real-world challenges.{" "}
                  </p>
                </div>
              </div>
              <div
                className="col-lg-5 col-auto d-lg-block d-none"
                data-aos="fade-left"
              >
                <div className="rounded-circle masthead-rounded-circle overflow-hidden">
                  <img
                    src="assets/images/career/about.jpg"
                    alt="about"
                    className="w-100"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="d-none section-common-space">
          <div className="container">
            <nav
              id="navbar-example2"
              className="navbar navbar-light bg-light px-3"
            >
              <ul className="nav nav-pills">
                <li className="nav-item">
                  <a className="nav-link" href="#scrollspyHeading11">
                    First
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#scrollspyHeading22">
                    Second
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </section>

        <div
          data-bs-spy="scroll"
          data-bs-target="#navbar-example2"
          data-bs-offset="0"
          className="scrollspy-example"
          tabindex="0"
        >
          <section
            id="scrollspyHeading11"
            className="benefits-section section-common-space"
          >
            <div className="container">
              <h1 className="subhead-bd text-primary-n label">Benefits</h1>
              <h2>What we Offer?</h2>
              <p>
                At Jio Institute, you will find a unique opportunity to be part
                of something transformative.
              </p>
              <div className="items">
                <div className="item">
                  <h3>Make an Impact That Matters</h3>
                  <p>
                    Be part of building an institution that is redefining
                    education, research, and innovation—driving meaningful
                    impact at scale.
                  </p>
                </div>
                <div className="item">
                  <h3>Build What Doesn’t Yet Exist</h3>
                  <p>
                    At Jio Institute, you don’t just join a system—you help
                    create it. Shape academic programs, research directions, and
                    institutional culture from the ground up.{" "}
                  </p>
                </div>
                <div className="item">
                  <h3>Where Academia Meets Industry </h3>
                  <p>
                    Work in an environment where academic excellence and
                    industry insight come together to solve real-world
                    challenges.{" "}
                  </p>
                </div>
                <div className="item">
                  <h3>Shape the Leaders of Tomorrow </h3>
                  <p>
                    Play a pivotal role in nurturing future leaders, innovators,
                    and changemakers who will influence society and the
                    economy.{" "}
                  </p>
                </div>
                <div className="item">
                  <h3>Thrive in a Future-Ready Ecosystem </h3>
                  <p>
                    Be part of a dynamic environment that embraces emerging
                    technologies and trends, preparing you to lead in a rapidly
                    evolving world.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section
            id="scrollspyHeading22"
            className="rewards-benefits-section section-common-space"
          >
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-4">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/3N4A2812.jpg"
                      alt="img"
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-8">
                  <h1 className="subhead-bd text-primary-n label">
                    Rewards & Benefits
                  </h1>
                  <h2>Our Commitment to You </h2>
                  <p>
                    We believe that exceptional talent deserves an enabling and
                    rewarding environment. We are committed to enabling
                    individuals who aim to perform at their highest
                    potential.{" "}
                  </p>
                  <div className="items">
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/compensation.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>Competitive and performance-linked compensation</p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/research-funding.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        Research funding and Seed grant support (for academic
                        roles)
                      </p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/development.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>Continuous learning and development opportunities</p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/wellness.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>Health and wellness benefits</p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/campus.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        Access to world-class campus facilities (sports
                        infrastructure, gymnasium, more)
                      </p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/work-culture.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        A collaborative and intellectually stimulating work
                        environment
                      </p>
                    </div>
                    <div className="item leadership-quality">
                      <div className="icon d-flex align-items-center justify-content-around">
                        <img
                          src="assets/images/rewards-benefits/exposure.svg"
                          alt=""
                          className="img-fluid"
                          width="100%"
                          height="auto"
                        />
                      </div>
                      <p>
                        Opportunities for global exposure and academic
                        partnerships
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            id="scrollspyHeading33"
            className="campus-design-section section-common-space"
          >
            <div className="container">
              <h1 className="subhead-bd text-primary-n label">
                A Campus Designed for Collaboration & Growth
              </h1>

              <div className="row">
                <div className="col-md-6 col-lg-8">
                  <p>
                    Jio Institute offers a vibrant ecosystem that supports both
                    professional excellence and personal well-being.
                  </p>
                  <p>
                    You will have access to continuous learning opportunities,
                    exposure to global best practices, and the ability to
                    contribute to impactful initiatives.
                  </p>
                  <p> Our ecosystem supports:</p>
                  <ul>
                    <li>Academic and professional development</li>
                    <li>Research and innovation initiatives</li>
                    <li>Interdisciplinary collaboration</li>
                    <li>Engagement with industry and global institutions</li>
                    <li>A vibrant and collaborative campus environment</li>
                  </ul>
                  <p>
                    We believe that our people are our greatest strength, and we
                    are committed to creating an experience that allows them to
                    thrive.
                  </p>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/JI Campus 1.jpg"
                      alt="img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="slider-circle-panel section-common-space overflow-hidden sectionnocolorbg hm-section-5">
            <div className="container">
              <div className="view-header">
                <h2
                  className="h2-02 font-black mb-2 heading-container-sm lh-1"
                  data-aos="fade-down"
                >
                  LIFE AT JIO INSTITUTE
                </h2>
                <p>
                  Our campus is designed to support collaboration, creativity,
                  and well-being.
                </p>
                <p>
                  With modern infrastructure, advanced facilities, and
                  thoughtfully designed spaces, we aim to create an environment
                  that enhances both professional and personal experiences.
                </p>
                <p>
                  Life at Jio Institute is enriched by a sense of community,
                  shared purpose, and opportunities for meaningful
                  engagement.{" "}
                </p>
              </div>
              <div className="facilities-slider mt-5">
                <div className="facilitiesslider">
                  <div className="academy1">
                    <div className="slick--view facilities-view1">
                      <div>
                        <img src="assets/images/campus-experience/academic-research/raj-sethuraman-class.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/academic-research/amy-banner.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/academic-research/dr-larry.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/academic-research/drfrank.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/academic-research/faculty-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/academic-research/faculty-2.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/academic-research/faculty-team.jpg" />
                      </div>

                      <div>
                        <img src="assets/images/campus-experience/academic-research/research.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="academy2">
                    <div className="slick--view facilities-view2">
                      <div>
                        <img src="assets/images/campus-experience/guest-lectures/dr-jlc.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="academy3">
                    <div className="slick--view facilities-view3">
                      <div>
                        <img src="assets/images/campus-experience/labs/labs-studio.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/labs/aids-lab.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/labs/computer-lab-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/labs/lab-1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="academy4">
                    <div className="slick--view facilities-view4">
                      <div>
                        <img src="assets/images/campus-experience/library/library-3.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/library/library-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/library/library-2.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="academy5">
                    <div className="slick--view facilities-view5">
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-dining-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-dining-2.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-discussion.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-lunch.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="academy6">
                    <div className="slick--view facilities-view6">
                      <div>
                        <img src="assets/images/campus-experience/gym/gym-Banner-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/gym/gym-Banner-2.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="academy7">
                    <div className="slick--view facilities-view7">
                      <div>
                        <img src="assets/images/campus-experience/celbrations-at-ji/christmas-banner.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/celbrations-at-ji/diwali-banner.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/celbrations-at-ji/festivals-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/celbrations-at-ji/festivals-2.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/celbrations-at-ji/ganpati-banner.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/celbrations-at-ji/independence-day-banner.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/gym/gym-Banner-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/gym/gym-Banner-2.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-dining-1.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-dining-2.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-discussion.jpg" />
                      </div>
                      <div>
                        <img src="assets/images/campus-experience/dining-collaborations/faculty-lunch.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="academybtncntr">
                  <li className="active" id="academy1">
                    <img src="assets/images/campus-experience/academic-research/Raj-Sethuraman-Class thumbnail.jpg" />

                    <span>Academics &amp; Research</span>
                  </li>
                  <li className="" id="academy2">
                    <img src="assets/images/campus-experience/guest-lectures/dr-jlc.jpg" />
                    <span>Guest Lecture</span>
                  </li>
                  <li className="" id="academy3">
                    <img src="assets/images/campus-experience/labs/Labs--STudio-Thumbnail.jpg" />
                    <span>Labs</span>
                  </li>
                  <li className="" id="academy4">
                    <img src="assets/images/campus-experience/library/Library---Thumbnail.jpg" />
                    <span>Library</span>
                  </li>
                  {/* <li className="" id="academy5">
							<img src="assets/images/campus-experience/dining-collaborations/faculty-dining-1.jpg" />
							<span>Dining | Collaboration</span>
						</li>
						<li className="" id="academy6">
							<img src="assets/images/campus-experience/gym/gym-Banner-1.jpg" />
							<span>Gym</span>
						</li>
						<li className="" id="academy7">
							<img src="assets/images/campus-experience/celbrations-at-ji/christmas-banner.jpg" />
							<span>Celebrations at JI</span>
						</li> */}
                  <li className="" id="academy7">
                    <img src="assets/images/campus-experience/dining-collaborations/faculty-dining-1.jpg" />
                    <span>Life @ JI</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          <section className="section-common-space bg-value overflow-hidden section-bg-red text-white wju-section-4 m-0 p-0 section-container">
            <div className="container">
              <div className={`row align-items-lg-center my-5 sec-4`}>
                <div className="col-12 col-lg">
                  <h3
                    className="h3-03 font-black text-lg-left text-center"
                    data-aos="fade-down"
                  >
                    Our Values
                  </h3>
                  <div className="d-lg-none mt-lg-0 mt-5">
                    <div className="rounded-circle masthead-rounded-circle-mob overflow-hidden">
                      <img
                        src="assets/images/career/our-values.png"
                        alt="about"
                        className="w-100"
                        width=""
                        height=""
                      />
                    </div>
                  </div>
                  <div className="row mb-5 mt-5">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={500}
                    >
                      <h5 className="h5-05 font-bold">Inclusiveness</h5>
                      <div className="body-02">
                        We foster an inclusive and caring environment that
                        embraces diverse backgrounds, identities and
                        perspectives. We treat all people with respect and
                        dignity. We listen to and encourage each other’s input
                        and opinion.
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={1000}
                    >
                      <h5 className="h5-05 font-bold">Freedom of inquiry</h5>
                      <div className="body-02">
                        We provide an environment where bright, curious and
                        critical minds work together to advance new ideas and
                        technologies. We collaborate to explore, persevere and
                        ultimately resolve challenges. All research upholds the
                        highest standards of academic rigour.
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={1500}
                    >
                      <h5 className="h5-05 font-bold">Integrity</h5>
                      <div className="body-02">
                        We take accountability and responsibility for our
                        actions, decisions and behaviours. We are honest and do
                        the right thing in order to preserve both our personal
                        and the Institute’s reputations. We work together in a
                        collaborative and collegiate manner.
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={2000}
                    >
                      <h5 className="h5-05 font-bold">Growth Mindset</h5>
                      <div className="body-02">
                        We possess a love of learning and continually strive to
                        develop and improve ourselves and support others to do
                        the same. We are resilient and accept challenges and
                        failures as opportunities to grow.
                      </div>
                    </div>
                  </div>
                  <div className="row mb-5">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={2500}
                    >
                      <h5 className="h5-05 font-bold">Excellence</h5>
                      <div className="body-02">
                        We have a mind-set of giving our best, seeking new and
                        better ways to approach challenges, utilising a digital
                        first approach and continually work to improve
                        ourselves. We hold ourselves and our colleagues
                        accountable to this value
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={3000}
                    >
                      <h5 className="h5-05 font-bold">Courage</h5>
                      <div className="body-02">
                        We are resilient, patient and tenacious. We embrace new
                        (and old) challenges with passion and conviction. We
                        stand up for what is right
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div
                      className="col-md-6"
                      data-aos="fade-in"
                      data-aos-duration={2500}
                    >
                      <h5 className="h5-05 font-bold">One Team</h5>
                      <div className="body-02">
                        We put the team ahead of our personal success and commit
                        to building its capability. We trust each other to
                        deliver on our respective obligations.
                      </div>
                    </div>
                    <div
                      className="col-md-6 mt-lg-0 mt-5"
                      data-aos="fade-in"
                      data-aos-duration={3000}
                    >
                      <h5 className="h5-05 font-bold">Ownership Mindset</h5>
                      <div className="body-02">
                        We maintain an ownership mind-set, viewing the company’s
                        success and reputation as paramount to our purpose. We
                        embrace accountability to drive accomplishment and
                        uphold the highest standards for safety and the
                        environment. We hold ourselves and our colleagues
                        accountable to this value.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-5 col-xl-auto d-lg-block d-none align-self-md-start">
                  <div className="rounded-circle masthead-rounded-circle overflow-hidden">
                    <img
                      src="assets/images/career/our-values.png"
                      width=""
                      height=""
                      alt="about"
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div className=" individual-who-wrapper layout layout--onecol sectionnocolorbg wju-section-3 section-container-3">
            <div className="layout__region layout__region--content">
              <div className="views-element-container container block block-views block-views-blockwork-with-us-block-1">
                <div className="content">
                  <div>
                    <div className="row view-inner-wrapper">
                      <div
                        className="view-header col-12 col-lg-6 col-xl-4"
                        data-aos="fade-right"
                      >
                        <h2 className="h2-02 font-black mb-2 heading-container-sm lh-1">
                          Career & Growth Pathways
                        </h2>
                        <p>
                          At Jio Institute, we offer diverse career
                          opportunities across academic and professional
                          domains.
                        </p>
                      </div>
                      <div
                        className="view-content row ol-12 col-lg-6 col-xl-8"
                        data-aos="fade-left"
                      >
                        <div className="views-row">
                          <h3>Faculty Careers</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Shape future leaders through teaching, research,
                                and academic leadership. Engage in curriculum
                                design, interdisciplinary teaching, and
                                impactful research.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="views-row">
                          <h3>Research Careers</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Work on cutting-edge research across emerging
                                domains with access to institutional support,
                                funding, and global collaborations.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="views-row">
                          <h3>Administrative and Professional Roles</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Drive institutional excellence across HR,
                                operations, student engagement, strategy, and
                                more.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="views-row">
                          <h3>Early Careers and Management Trainees</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Our early career programs are designed to
                                nurture future leaders through structured
                                learning, cross-functional exposure, and
                                hands-on experience.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="section-common-space overflow-hidden leadership-vision-section">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <h1 class="subhead-bd text-primary-n label">
                    What Drives Us?
                  </h1>
                  <h2 className="h2-02 font-black mb-2 heading-container-sm m-auto">
                    LEADERSHIP & VISION
                  </h2>
                  <p>Work with global scholars and thought leaders</p>
                </div>
              </div>{" "}
              <div className="row slider-circle-panel pb-2 pt-4">
                <div className="col-12 text-center">
                  <div className="provos-section-slider equal_height_cards  justify-content-center text-center ">
                    {/* <Slider {...settings}> */}
                    <div className="row justify-content-around">
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="card h-100 border-0 radius-16 overflow-hidden">
                          <div className="rounded-circle img-dimension  overflow-hidden">
                            <img
                              src="assets/images/leader-image/Dr-Mashelkar_0.png.webp"
                              // src="https://www.jioinstitute.edu.in/sites/default/files/styles/webp/public/leader_image/Dr-Mashelkar_0.png.webp?itok=1FJQJYfw"
                              alt="about"
                              className="w-50 rounded-circle m-auto leaders-img"
                            />
                          </div>
                          <div className="card-body leader-card-body">
                            <div className="font-bold mb-2 primary text-uppercase body-02"></div>
                            <h4 className="font-bold f-24 leader-title ">
                              Dr. Raghunath Mashelkar
                            </h4>
                            <span className="profile-text overline-01 text-uppercase font-bold">
                              Chancellor
                            </span>

                            <p className="font-small ml-auto mr-auto mt-2 w-65">
                              Padma Vibhushan | Former Director General, CSIR,
                              Government of India
                            </p>
                          </div>
                          <div className="card-footer pt-0 border-0">
                            <a
                              href="https://www.jioinstitute.edu.in/about/chancellor"
                              className="btn btn-secondary"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Know more
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-lg-4">
                        <div className="card h-100 border-0 radius-16 overflow-hidden">
                          <div className="rounded-circle img-dimension  overflow-hidden">
                            <img
                              src="assets/images/leader-image/Dipak-Jain_1.png.webp"
                              // src="https://www.jioinstitute.edu.in/sites/default/files/styles/webp/public/leader_image/Dipak-Jain_1.png.webp?itok=MXpYvydw"
                              alt="about"
                              className="w-50 rounded-circle m-auto leaders-img"
                            />
                          </div>
                          <div className="card-body leader-card-body">
                            <div className="font-bold mb-2 primary text-uppercase body-02"></div>
                            <h4 className="font-bold f-24 leader-title">
                              Dr. Dipak Jain
                            </h4>
                            <span className="profile-text overline-01 text-uppercase font-bold">
                              VICE-CHANCELLOR
                            </span>

                            <p className="font-small ml-auto mr-auto mt-2 w-75">
                              Former Dean, Kellogg School of Management, USA |
                              Former Dean, INSEAD, France
                            </p>
                          </div>
                          <div className="card-footer pt-0 border-0 ">
                            <a
                              href="https://www.jioinstitute.edu.in/about/vice-chancellor"
                              className="btn btn-secondary"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Know more
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="section-common-space sectionnocolorbg section-container research-innovation-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-6" data-aos="fade-right">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/Student L&D.jpg"
                      alt="Research and Innovation"
                      className="w-100"
                    />
                  </div>
                  <h3 className="mt-4">RESEARCH & INNOVATION</h3>
                  <div className="body-02 section-copy">
                    <p>Research is at the core of Jio Institute’s vision.</p>
                    <p>
                      We are building a research-intensive ecosystem that
                      encourages inquiry, supports experimentation, and drives
                      innovation across disciplines.
                    </p>
                    <p>
                      Our focus includes emerging and impactful areas such as
                      technology, data sciences, sustainability, and societal
                      development.
                    </p>
                    <p>
                      We actively promote collaboration with industry,
                      government, and global academic institutions to ensure
                      that our research contributes to real-world solutions.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 mt-5 mt-lg-0" data-aos="fade-left">
                  <div className="img-box">
                    <img
                      src="/assets/images/career/3N4A2756.jpg"
                      alt="Research and Innovation"
                      className="w-100"
                    />
                  </div>
                  <h3 className="mt-4">DIVERSITY, EQUITY & INCLUSION</h3>
                  <div className="body-02 section-copy">
                    <p>
                      We believe that diversity is fundamental to innovation and
                      excellence.
                    </p>
                    <p>
                      Jio Institute is committed to fostering an inclusive
                      environment where individuals from diverse backgrounds
                      feel valued, respected, and empowered.
                    </p>
                    <p>
                      We actively seek to build a global community that reflects
                      a wide range of perspectives, experiences, and ideas.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-12 text-center">
                  <h3 className="h3-03 font-black mb-3">
                    Voices from Jio Institute
                  </h3>
                  <p className="body-02 mx-auto research-summary">
                    Our people are at the heart of everything we do. Their
                    experiences reflect the collaborative, innovative, and
                    purpose-driven environment that defines Jio Institute. Our
                    people bring our vision to life.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <section className="d-none section-common-space sectioncolorbg-why-join-us wju-section-2 section-container">
          <div className="container">
            <div className="card-group d-flex flex-wrap eq-h-tile">
              <div className="card" data-aos="fade-in" data-aos-duration={200}>
                <div className="leadership-quality d-flex align-items-center mb-lg-5 m-0">
                  <div className="icon d-flex align-items-center justify-content-around">
                    <img
                      src="assets/images/career/icon-leadership.svg"
                      alt=""
                      className="img-fluid"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="details font-medium">
                    <div className="body-02">
                      Benefit from Founders’ transformative precedents in the
                      business world and philanthropy via Reliance ecosystem
                    </div>
                  </div>
                </div>
              </div>
              <div className="card" data-aos="fade-in" data-aos-duration={1200}>
                <div className="leadership-quality d-flex align-items-center mb-lg-5 m-0">
                  <div className="icon d-flex align-items-center justify-content-around">
                    <img
                      src="assets/images/career/icon-integrated.svg"
                      alt=""
                      className="img-fluid"
                      width="64px"
                      height="auto"
                    />
                  </div>
                  <div className="details font-medium">
                    <div className="body-02">
                      Be an integral part of the core team that can take pride
                      in laying a solid foundation for institution building in
                      the long run
                    </div>
                  </div>
                </div>
              </div>
              <div className="card" data-aos="fade-in" data-aos-duration={2200}>
                <div className="leadership-quality d-flex align-items-center mb-lg-5 m-0">
                  <div className="icon d-flex align-items-center justify-content-around">
                    <img
                      src="assets/images/career/icon-digital-thinking.svg"
                      alt=""
                      className="img-fluid"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="details font-medium">
                    <div className="body-02">
                      A plethora of prospects to explore other than your core
                      competencies
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card mb-lg-0"
                data-aos="fade-in"
                data-aos-duration={2200}
              >
                <div className="leadership-quality d-flex align-items-center m-0">
                  <div className="icon d-flex align-items-center justify-content-around">
                    <img
                      src="assets/images/career/icon-goal.svg"
                      alt=""
                      className="img-fluid"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="details font-medium">
                    <div className="body-02">
                      Once-in-a-lifetime opportunity to implement a clearly
                      charted out growth plan
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card mb-lg-0"
                data-aos="fade-in"
                data-aos-duration={1200}
              >
                <div className="leadership-quality d-flex align-items-center m-0">
                  <div className="icon d-flex align-items-center justify-content-around">
                    <img
                      src="assets/images/career/icon-communication-skill.svg"
                      alt=""
                      className="img-fluid"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="details font-medium">
                    <div className="body-02">
                      Be a part of a community where passion and ownership are
                      contagious
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card mb-lg-0"
                data-aos="fade-in"
                data-aos-duration={200}
              >
                <div className="leadership-quality d-flex align-items-center m-0">
                  <div className="icon d-flex align-items-center justify-content-around">
                    <img
                      src="assets/images/career/icon-entrepreneurial-virtues.svg"
                      alt=""
                      className="img-fluid"
                      width="100%"
                      height="auto"
                    />
                  </div>
                  <div className="details font-medium">
                    <div>
                      Be part of a digitally driven culture of innovation,
                      collaboration and entrepreneurship.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className=" d-none individual-who-wrapper layout layout--onecol sectionnocolorbg wju-section-3 section-container-3">
          <div className="layout__region layout__region--content">
            <div className="views-element-container container block block-views block-views-blockwork-with-us-block-1">
              <div className="content">
                <div>
                  <div className="row view-inner-wrapper">
                    <div className="view-header col-lg-4" data-aos="fade-right">
                      <h2 className="font-medium">
                        We seek <br /> individuals who…
                      </h2>
                    </div>
                    <div
                      className="view-content row col-lg-8"
                      data-aos="fade-left"
                    >
                      <div className="views-row">
                        <div className="views-field views-field-field-slider-image">
                          <div className="field-content">
                            {" "}
                            <img
                              src="assets/images/files//Collaborate.svg"
                              alt="Collaborate"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                        </div>
                        <div className="views-field views-field-field-slider-description">
                          <div className="field-content">
                            <p>
                              <strong>Collaborate </strong>with likeminded
                              persons to address complex problems.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="views-row">
                        <div className="views-field views-field-field-slider-image">
                          <div className="field-content">
                            {" "}
                            <img
                              src="assets/images/files//Excellence.svg"
                              alt="Excellence"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                        </div>
                        <div className="views-field views-field-field-slider-description">
                          <div className="field-content">
                            <p>
                              Are committed to <strong>excellence</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="views-row">
                        <div className="views-field views-field-field-slider-image">
                          <div className="field-content">
                            {" "}
                            <img
                              src="assets/images/files//Digital-Thinking.svg"
                              alt="Digital Thinking"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                        </div>
                        <div className="views-field views-field-field-slider-description">
                          <div className="field-content">
                            <p>
                              Are excited about the benefits, opportunities and
                              challenges offered by technology and{" "}
                              <strong>digital thinking</strong>.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="views-row">
                        <div className="views-field views-field-field-slider-image">
                          <div className="field-content">
                            {" "}
                            <img
                              src="assets/images/files/Lifelong-Learners.svg"
                              alt="Lifelong Learners"
                              loading="lazy"
                              typeof="foaf:Image"
                            />
                          </div>
                        </div>
                        <div className="views-field views-field-field-slider-description">
                          <div className="field-content">
                            <p>
                              Are <strong>lifelong learners</strong>.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="views-row m-lg-0">
                        <div className="views-field views-field-field-slider-image">
                          <div className="field-content">
                            {" "}
                            <img
                              src="assets/images/files/Innovation.svg"
                              alt="Innovation"
                              loading="lazy"
                              typeof="foaf:Image"
                              style={{ width: "28px" }}
                            />
                          </div>
                        </div>
                        <div className="views-field views-field-field-slider-description">
                          <div className="field-content">
                            <p className="m-0">
                              Are curious to explore globally significant
                              questions through <strong>education</strong>,{" "}
                              <strong>research </strong>and{" "}
                              <strong>innovation</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="d-none section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg wju-section-5 my-0 py-0 sectionnocolorbg section-container">
          <div className="container">
            <div className="row align-items-lg-center">
              <div
                className="col-auto d-lg-block d-none col-lg-5"
                data-aos="fade-right"
              >
                <div className="rounded-circle masthead-rounded-circle overflow-hidden">
                  <img
                    src="assets/images/At-the-institute-you-will.jpg"
                    className="w-100"
                  />
                </div>
              </div>
              <div className="col col-lg-6 offset-lg-1" data-aos="fade-left">
                <div className="d-lg-none">
                  <div className="rounded-circle masthead-rounded-circle-mob overflow-hidden">
                    <img
                      src="assets/images/At-the-institute-you-will.jpg"
                      alt=""
                      className="w-100"
                    />
                  </div>
                </div>
                <div className="h4-04">
                  <h2 className="d-none font-medium mb-4 f-42">
                    At the Institute, you will:
                  </h2>
                  <p>
                    Jio Institute is guided by a leadership team that brings
                    together deep academic expertise and industry experience.
                  </p>
                  <p>
                    Our vision is to establish a globally respected university
                    that combines academic excellence with innovation and
                    societal impact.
                  </p>
                  <p>
                    Through strategic direction and collaborative leadership, we
                    are committed to building an institution that sets new
                    benchmarks in higher education.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="slider-circle-panel neutral-10-bg section-common-space pt-0 pb-0 window-height  d-flex align-items-center justify-content-center wju-section-6"
          style={{
            backgroundImage: "url(assets/images/career/navi-mumbai-jic.jpg)",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          data-aos="fade-in"
        ></section>

        {/* React slick slider  */}
        <section
          className="section-common-space pt-0 pb-0 window-height slick-section-container d-none"
          id="trigger6"
        >
          <div className="location-slider locationSlider">
            <Slider {...settings}>
              <div className="position-relative cmp-slick">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <div className="d-flex justify-content-end">
                        <div className="containt">
                          <h3 className="h3-03 font-black">
                            A Campus of Opportunities
                          </h3>
                          <div className="body-01 font-medium">
                            Jio Institute campus is strategically located at
                            Ulwe in Navi Mumbai, near the upcoming Navi Mumbai
                            International Airport and the Mumbai Trans Harbour
                            Link.
                          </div>
                          <div className="pt-3" />
                          <div className="body-01 font-medium">
                            Also, as the financial capital of India and one most
                            prominent cities in the world, Mumbai welcomes
                            millions of people every year who come here to
                            achieve their dreams. The city is teeming with the
                            world’s top MNCs and bustling with people from every
                            culture, ethnicity, and strata of society. This
                            makes our campus an ideal place for learners to
                            explore careers post-completing their courses.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="campus_bg">
                  <img
                    // src="assets/images/career/navi-mumbai-jic.jpg"
                    src="assets/images/career/navi-mumbai-dekstop.png"
                    className="w-100  data-img"
                    alt=""
                    data-sml="assets/images/career/nav-mumbai-mobile.png"
                    data-med="assets/images/career/navi-mumbai-tab.png"
                    data-lrg="assets/images/career/navi-mumbai-dekstop.png"
                  />
                </div>
              </div>
            </Slider>
          </div>
        </section>
      </div>
    </>
  );
}

export default WhyJoinUs;
